import { useCallback, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface AdminUser {
  user_id: string;
  email: string;
  created_at: string;
  is_self: boolean;
}

/**
 * Gestione amministratori tramite le RPC list_admins / add_admin_by_email /
 * remove_admin: girano lato DB, richiedono un admin con 2FA (aal2) e
 * scrivono da sole nel registro audit.
 */
export function useAdmins() {
  const [admins, setAdmins] = useState<AdminUser[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchAdmins = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase.rpc('list_admins');
    setLoading(false);
    if (error) throw new Error(error.message);
    setAdmins((data as AdminUser[]) || []);
  }, []);

  const addAdmin = async (email: string) => {
    const { error } = await supabase.rpc('add_admin_by_email', { p_email: email });
    if (error) throw new Error(error.message);
    await fetchAdmins();
  };

  const removeAdmin = async (userId: string) => {
    const { error } = await supabase.rpc('remove_admin', { p_user_id: userId });
    if (error) throw new Error(error.message);
    await fetchAdmins();
  };

  return { admins, loading, fetchAdmins, addAdmin, removeAdmin };
}
